"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createYanziLink = void 0;
const client_1 = require("@apollo/client");
const performRequest_1 = require("./performRequest");
function createYanziLink(socket) {
    return new client_1.ApolloLink(operation => {
        return new client_1.Observable(observer => {
            performRequest_1.performRequest({ operation, socket })
                .then(result => {
                if (!observer.closed) {
                    observer.next(result);
                    observer.complete();
                }
            })
                .catch(error => {
                if (!observer.closed) {
                    observer.error(error);
                    observer.complete();
                }
            });
        });
    });
}
exports.createYanziLink = createYanziLink;
//# sourceMappingURL=index.js.map